import { CheckCircle, Mail } from 'lucide-react'
import type { NodeExecution } from 'sprites-types/api/v2/workflows'
import { getToolResultSchema } from 'sprites-types/workflow/tools/common'
import { gmailSendEmail } from 'sprites-types/workflow/tools/gmailSendEmail'
import {
  createWorkflowToolComponent,
  type WorkflowToolComponentProps,
} from '../shared/WorkflowToolComponent'
import { SchemaValidationError } from '../shared/safeParseToolResult'

function GmailSendEmailDisplayComponent({ nodeExecution }: WorkflowToolComponentProps) {
  const schema = getToolResultSchema(gmailSendEmail, nodeExecution.inputs)
  const parseResult = schema.safeParse(nodeExecution.outputs)

  if (!parseResult.success) {
    return <SchemaValidationError error={parseResult.error} nodeExecution={nodeExecution} />
  }

  const result = parseResult.data
  const inputs = nodeExecution.inputs

  const recipient = inputs.to || 'recipient'
  const subject = inputs.subject || 'No subject'
  const messageId = (result as any)?.messageId || (result as any)?.id

  return (
    <div className="rounded-3xl border border-gray-200/50 bg-white/70 text-black shadow-xl backdrop-blur-[8px]">
      <div className="flex items-center gap-4 px-4 py-3">
        <div className="flex-shrink-0">
          <div className="rounded-full bg-green-100 p-2">
            <CheckCircle className="h-5 w-5 text-green-600" />
          </div>
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-sm font-semibold text-gray-900">Email sent successfully</div>
          <div className="text-xs text-gray-600">
            To: {recipient} • Subject: {subject}
          </div>
          {messageId && <div className="mt-1 text-xs text-gray-500">Message ID: {messageId}</div>}
        </div>
        <div className="flex-shrink-0">
          <Mail className="h-5 w-5 text-gray-400" />
        </div>
      </div>
    </div>
  )
}

function downloadGmailSendEmail(_nodeExecution: NodeExecution): Promise<void> {
  return Promise.resolve()
}

function gmailSendEmailToMarkdown(nodeExecution: NodeExecution): string {
  const inputs = nodeExecution.inputs
  const recipient = inputs.to || 'recipient'
  const subject = inputs.subject || 'No subject'

  return `## Email Sent Successfully

**To:** ${recipient}
**Subject:** ${subject}

---
`
}

export const GmailSendEmailDisplay = createWorkflowToolComponent(
  GmailSendEmailDisplayComponent,
  downloadGmailSendEmail,
  gmailSendEmailToMarkdown
)
